import { render, staticRenderFns } from "./TableNamesCard.vue?vue&type=template&id=23edaa92&scoped=true&"
import script from "./TableNamesCard.vue?vue&type=script&lang=js&"
export * from "./TableNamesCard.vue?vue&type=script&lang=js&"
import style0 from "./TableNamesCard.vue?vue&type=style&index=0&id=23edaa92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23edaa92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
